(function ($) {
	"use strict";
	
	$(window).on('load', function() {
		VegasListener.onLoad();
	});
	
	$(window).scroll(function () {
		VegasListener.onScroll($(this));
	});
	
	$(document).ready(function () {
		VegasListener.onReady();
		VegasListener.onClick();
		VegasListener.onSubmit();
	});
	
	// [vegas]
	Vegas.log();
})(jQuery);